<div class="yes-no">
  <div class="yes-no__close">
    <mat-icon (click)="dialogRef.close()">close</mat-icon>
  </div>
  <h2 class="yes-no__title">{{data?.title}}</h2>
  <div class="yes-no__controls">
    <button mat-button class="btn btn-blue" (click)="dialogRef.close(true)">ДА</button>
    <button mat-button class="btn btn-grey" (click)="dialogRef.close(false)">НЕТ</button>
  </div>
</div>
